import { Box, Stack } from "@mantine/core";
import style from "./privacy.module.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PrivacyMenu } from "./privacy-menu";

export const PrivacyPage = () => {
    const { t } = useTranslation(['privacy']);
    
    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.contentWrapper}>
                    <Stack className={style.menuContent} spacing={"0.5rem"} mt={"10rem"}>
                        <PrivacyMenu />
                    </Stack>

                    <Box className={style.textContent} spacing={"0.5rem"} mt={"8rem"}>
                        <article>
                            <h1 className={style.header1}>{t("privacy.title")}</h1>

                            <p>{t("privacy.intro")}</p>

                            <br />
                            <h2 className={style.header2}>{t("privacy.trust.title")}</h2>
                            <p>{t("privacy.trust.description")}</p>

                            <br />
                            <h2 className={style.header2}>{t("privacy.dataSecurity.title")}</h2>
                            <p>{t("privacy.dataSecurity.storage")}</p>
                            <br />
                            <p>{t("privacy.dataSecurity.reliability")}</p>
                            <br />
                            <p>{t("privacy.dataSecurity.testing")}</p>
                            <br />
                            <p>{t("privacy.dataSecurity.noTraining")}</p>
                            <br />
                            <p>
                                {t("privacy.dataSecurity.readMore")}
                                <Link className={style.linkInline} to="/privacy-policy">
                                    {t("privacy.dataSecurity.privacyPolicyLink")}
                                </Link>
                            </p>

                            <br />
                            <h2 className={style.header2}>{t("privacy.gdpr.title")}</h2>
                            <p>{t("privacy.gdpr.compliance")}</p>
                            <br />
                            <p>{t("privacy.gdpr.dataSharing")}</p>
                            <br />
                            <p>
                                <Link className={style.linkInline} to="/gdpr">
                                    {t("privacy.gdpr.readMoreLink")}
                                </Link>
                            </p>

                            <br />
                            <h2 className={style.header2}>{t("privacy.reporting.title")}</h2>
                            <p>{t("privacy.reporting.description")}</p>
                            <br />
                            <p>
                                {t("privacy.reporting.visitText")}
                                <Link className={style.linkInline} to="/responsible-reporting">
                                    {t("privacy.reporting.policyLink")}
                                </Link>
                                {t("privacy.reporting.readPolicy")}
                            </p>
                        </article>
                    </Box>
                </div>
            </div>
        </div>
    );
};
